import script from "./TopDashboardsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopDashboardsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopDashboardsPanel.vue?vue&type=style&index=0&id=209594d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-209594d0"]])

export default __exports__